import React from 'react';

import {
  EuiDatePicker
} from '@elastic/eui';

const SelectorFecha = (props) => {

  return (
        <EuiDatePicker
          dateFormat="DD-MM-YYYY"
          locale="es-es"
          {...props}
        />
  );
};

export default SelectorFecha;